const filterFormatter = (filter: string) => {
  if (filter === 'Todos') {
    return ''
  }

  return filter
}

export default filterFormatter
